import script from "./input-plate-no.vue?vue&type=script&setup=true&lang=js"
export * from "./input-plate-no.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__